import { Log } from "../events/CoreTelemetry.event";
/**
 * Emits Core Telemetry events through the shared log handler.
 */ export class CoreTelemetryLogger {
    log() {
        Log(this.logHandler);
    }
    constructor(logHandler){
        this.logHandler = logHandler;
    }
}
